import { render, staticRenderFns } from "./delivery-notice.vue?vue&type=template&id=167f8ee3"
import script from "./delivery-notice.ts?vue&type=script&lang=ts&external"
export * from "./delivery-notice.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports